import { mapGetters, mapActions } from 'vuex'
import Purchase from '@/api/purchase'

export default {
  props: {
    purchase: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      loading: 'skiliko/purchases/isLoading'
    }),
    service () {
      return this.purchase.service
    },
    isPending () {
      return Purchase.isPending(this.purchase)
    },
    isInProgress () {
      return Purchase.isInProgress(this.purchase)
    },
    isFinished () {
      return Purchase.isFinished(this.purchase)
    }
  },
  methods: {
    ...mapActions({
      accept: 'skiliko/purchases/accept',
      _finish: 'skiliko/purchases/finish'
    }),
    finish (data) {
      return this._finish({
        id: this.purchase.id,
        serviceType: this.purchase.offer.service_type,
        data
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/purchase.js